<div class="sa-ticket-create-dialog">
  <div class="title-container">
    <span class="title-icon {{ data.icon }}"></span>
    <span class="title-text">{{ data.title }}</span>
    <div class="xs-dialog-close-btn" (click)="cancel()"></div>
  </div>
  <div class="dialog-header-separator"></div>
  <div class="new-incident-middle">
    <div class="select-label">
      <span>{{ 'createTicket_selectgroup_caption' | xsI18n }}</span>
    </div>
    <div class="mat-select-holder">
      <div class="mat-drowpdown-selector-custom">
        <soti-select
          [maxHeight]="255"
          [(ngModel)]="selectedGroupId"
          (ngModelChange)="onGroupIdChange($event)"
          class="filter"
        >
          <soti-option
            *ngFor="let opt of groups"
            [value]="opt.groupId"
            class="dropdown-option ellipsis-tooltip"
          >
            <span class="group-label">
              {{ opt.groupName }}
            </span>
          </soti-option>
        </soti-select>
      </div>
    </div>
  </div>

  <div class="buttons-container modal-footer">
    <button class="xs-btn btn-outline btn-space" (click)="cancel()">
      {{ 'xs_cancel_label' | xsI18n }}
    </button>
    <button class="xs-btn btn-primary" (click)="confirm()">
      {{ 'createTicket_Create_Button' | xsI18n }}
    </button>
  </div>
</div>
